import router from '@/router/index.js';
export default {
  // called when the bound element's parent component
  // and all its children are mounted.
  mounted (el, binding, vnode, prevVnode) {
    el.addEventListener('click', function () {
      if (binding.value) {
        const value = binding.value;

        const isString = typeof value === 'string';
        const target = isString ? '_self' : value.target || '_self';

        if (router.hasRoute(value) || router.hasRoute(binding.value.name)) {
          if (target === '_blank') {
            const route = isString ? { name: value } : { ...value };
            const resolved = router.resolve(route);
            window.open(resolved.href, '_blank', 'noopener,noreferrer');
          } else {
            const gotoRoute = (typeof binding.value === 'string') ? { name: binding.value } : binding.value;
            router.push(gotoRoute);
          }
        }
      }
    });
  }
};
